import React from 'react';
import Loadable from 'react-loadable';
import Loading from 'components/Loading';

const GalleryFunctionLoadable = Loadable({
  loader: () => import('./GalleryFunction')
    .then(module => module.default)
    .catch(() => { if (window) window.location.reload(); }),
  loading: () => <div key="GalleryFunctionLoadable"><Loading /></div>
});

export default GalleryFunctionLoadable;
